export default __webpack_public_path__ + "static/media/pct.cc2c25f8.ttf";